(function () {
  const DESKTOP_MQ = window.matchMedia('(min-width: 990px)');
  const CLOSE_DELAY = 320;
  let closeTimer = null;
  let panel = null;

  function isDesktop() {
    return DESKTOP_MQ.matches;
  }

  function getTriggers() {
    return document.querySelectorAll('[data-ksp-mega-trigger]');
  }

  function setActiveL1(handle) {
    if (!panel) return;

    panel.querySelectorAll('[data-ksp-tree-l1]').forEach((tree) => {
      tree.hidden = tree.dataset.kspTreeL1 !== handle;
    });

    getTriggers().forEach((trigger) => {
      const active = trigger.dataset.kspMegaTrigger === handle;
      trigger.classList.toggle('ksp-nav-trigger--open', active);
      trigger.setAttribute('aria-expanded', active ? 'true' : 'false');
    });

    const tree = panel.querySelector(`[data-ksp-tree-l1="${handle}"]`);
    const firstL2 = tree?.querySelector('[data-ksp-l2]');
    if (firstL2) setActiveL2(handle, firstL2.dataset.kspL2);
  }

  function loadSubtreeImages(group) {
    if (!group) return;
    group.querySelectorAll('img.ksp-mega-panel__product-image[data-src]:not([data-loaded])').forEach((img) => {
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      if (img.dataset.src) img.src = img.dataset.src;
      img.dataset.loaded = 'true';
    });
  }

  function setActiveL2(l1Handle, l2Handle) {
    if (!panel) return;

    const tree = panel.querySelector(`[data-ksp-tree-l1="${l1Handle}"]`);
    if (!tree) return;

    tree.querySelectorAll('[data-ksp-l2]').forEach((btn) => {
      btn.classList.toggle('is-active', btn.dataset.kspL2 === l2Handle);
    });

    let activeGroup = null;
    tree.querySelectorAll('[data-ksp-l3-group]').forEach((group) => {
      const isActive = group.dataset.kspL3Group === l2Handle;
      group.hidden = !isActive;
      if (isActive) activeGroup = group;
    });

    loadSubtreeImages(activeGroup);
  }

  function isSearchOpen() {
    return Boolean(document.querySelector('.header__search details[open]'));
  }

  function openPanel(handle) {
    if (!isDesktop() || !panel) return;
    if (isSearchOpen()) return;
    clearTimeout(closeTimer);
    panel.hidden = false;
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    setActiveL1(handle);
  }

  function closePanel() {
    if (!panel) return;
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    getTriggers().forEach((trigger) => {
      trigger.classList.remove('ksp-nav-trigger--open');
      trigger.setAttribute('aria-expanded', 'false');
    });
    setTimeout(() => {
      if (!panel.classList.contains('is-open')) panel.hidden = true;
    }, 200);
  }

  function scheduleClose() {
    if (!isDesktop()) return;
    clearTimeout(closeTimer);
    closeTimer = setTimeout(closePanel, CLOSE_DELAY);
  }

  function bindEvents() {
    panel = document.getElementById('KspMegaPanel');
    if (!panel) return;

    const hoverZone = document.querySelector('.header-wrapper');

    getTriggers().forEach((trigger) => {
      trigger.addEventListener('mouseenter', () => openPanel(trigger.dataset.kspMegaTrigger));
      trigger.addEventListener('focus', () => openPanel(trigger.dataset.kspMegaTrigger));
    });

    panel.querySelectorAll('[data-ksp-l2]').forEach((btn) => {
      btn.addEventListener('mouseenter', () => {
        const tree = panel.querySelector(`[data-ksp-tree-l1="${btn.dataset.kspParent}"]`);
        const group = tree?.querySelector(`[data-ksp-l3-group="${btn.dataset.kspL2}"]`);
        loadSubtreeImages(group);
        setActiveL2(btn.dataset.kspParent, btn.dataset.kspL2);
      });
      btn.addEventListener('focus', () => {
        setActiveL2(btn.dataset.kspParent, btn.dataset.kspL2);
      });
    });

    panel.addEventListener('mouseenter', () => clearTimeout(closeTimer));
    hoverZone?.addEventListener('mouseleave', scheduleClose);

    panel.querySelector('[data-ksp-mega-close]')?.addEventListener('click', closePanel);

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closePanel();
    });

    // Suche offen → Mega-Menü sofort schließen und nicht wieder öffnen
    document.querySelectorAll('.header__search details').forEach((details) => {
      details.addEventListener('toggle', () => {
        if (details.open) closePanel();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', bindEvents);
  DESKTOP_MQ.addEventListener('change', () => {
    if (!isDesktop()) closePanel();
  });
})();
